<template>
  <div :class="`Header ${offsetTop > 100 ? 'headerBlack' : ''}`">
    <div class="pageContent-w header-content">
      <div class="logo" @click="goPage('/')">
        <img src="@/assets/image/logo.png" alt="" />
        <span>{{ appName }}</span>
      </div>
      <div class="navBox">
        <div
          :class="`navItem ${item.path == route.path ? 'active' : ''}`"
          v-for="(item, index) in navList"
          :key="index"
          @click="goPage(item.path)">
          {{ item.name.toUpperCase() }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useRouter, useRoute} from "vue-router";
import {t} from '@/lang'

const navList = ref([
  {
    name: t("header.text1"),
    path: "/home",
  },
  {
    name: t("header.text2"),
    path: "/policy",
  },
]);

const route = useRoute();
const router = useRouter();
const appName = ref("BULANADESIXINGGONG");

const goPage = (url) => {
  router.push(url);
};

const offsetTop = ref(0);
const handleScroll = () => {
  offsetTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
};

onMounted(() => {
  handleScroll();
  window.addEventListener("scroll", handleScroll); //监听滚动事件
});
</script>

<style lang="scss" scoped>
.Header {
  height: 8rem;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  background: transparent;
  color: #000;
  background-color: #fff;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    font-size: 2rem;

    .logo {
      display: flex;
      align-items: center;
      height: 100%;
      cursor: pointer;
      img {
        height: 5rem;
      }
      span {
        margin-left: 1rem;
        font-weight: bold;
        font-size: 2.8rem;
      }
    }
    .navBox {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 2rem;
      .navItem {
        margin: 0 3rem;
        padding: 1.5rem 0;
        border-bottom: 0.35rem solid transparent;
        cursor: pointer;
        &:hover {
          border-color: #858585;
        }
      }
      .active {
        border-color: #858585;
      }
    }
  }
}
.headerBlack {
  box-shadow: 0 0 10px 2px #0000003d;
}

@keyframes identifier {
  0% {
    background-color: transparent;
    height: 0;
  }
  100% {
    background-color: #fff;
  }
}
</style>
